import { mapChipFieldOptions } from 'features/consults/utils/formFields';
import { neuroAssessmentFields } from 'features/consults/shared/tabs/Assessment/formFields';
import { ConsultAttestationEnum, NeuroConsultTypes } from 'utils/enums';

export default (attestationValue, consultType) => {
  const isFollowUpPhoneCall = attestationValue === ConsultAttestationEnum.followUpPhoneCall;
  const isFollowUpConsultType = consultType === NeuroConsultTypes.FOLLOW_UP;
  const shouldSkipImpression = isFollowUpPhoneCall || isFollowUpConsultType;
  
  const impressionField = {
    ...neuroAssessmentFields.impressionPredefined,
    required: !shouldSkipImpression,
  };

  return {
    elements: [
      mapChipFieldOptions(impressionField),
      neuroAssessmentFields.impressionFreeText,

      mapChipFieldOptions(neuroAssessmentFields.differentialDiagnosisPredefined),
      neuroAssessmentFields.differentialDiagnosisFreeText,
    ],
  };
};
